import { makeStyles } from '@material-ui/core';
import APIMapping from './APIMapping';

const useStyle = makeStyles(() => ({
  root: {
    borderRadius: '0 0.937rem 0.937rem',
    backgroundColor: '#ffffff',
    padding: '1.875rem 1.875rem 0',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
}));

const BedStatus = () => {
  const classes = useStyle();

  return (
    <div className={classes.root}>
      <APIMapping />
    </div>
  );
};

export default BedStatus;
